module.exports = __webpack_public_path__ + "img/user.b459f732.svg";